import React from "react";
import { HeaderContainer } from "./style";
import Logo from "../../../../components/logo";
import Back from "../../../../components/back";

export const Header = props => {
  return (
    <HeaderContainer>
      <Back noLabel />

      <Logo
        onClick={() => {
          window.location.href = "/";
        }}
      />
      <div className="title">{props.title}</div>
    </HeaderContainer>
  );
};
